// extracted by mini-css-extract-plugin
export default {"fullView":"ProjectFullView_fullView__mK8v-","breadcrumb":"ProjectFullView_breadcrumb__7RETR"};